import { useContext, useEffect, useRef } from "react";

import SignalRContext from "../signalRContext";

export const useSignalREvent = <T = unknown>(
    event: string | undefined,
    handler: (data: T) => void
) => {
    const { connection } = useContext(SignalRContext);

    const handlerRef = useRef(handler);
    handlerRef.current = handler; // latest handler, no resubscribe on every render

    useEffect(() => {
        if (!connection || !event) return;

        const callbackFn = (data: T) => handlerRef.current(data);
        connection.on(event, callbackFn);

        return () => connection.off(event, callbackFn);
    }, [connection, event]);
};
